import { Component, OnInit, input, ChangeDetectionStrategy } from '@angular/core';
import { Citation } from '../../../store/models/citation.model';
import { MomentModule } from 'ngx-moment';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'gnx-citations-tile',
  templateUrl: './citations-tile.component.html',
  styleUrls: ['./citations-tile.component.scss'],
  imports: [MatTooltip, MomentModule],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CitationsTileComponent implements OnInit {
  readonly citation = input<Citation>(undefined);

  constructor() {}

  ngOnInit(): void {}
}
